// extracted by mini-css-extract-plugin
export var navbarSubLink = "K_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "K_t5 d_f0 d_dB";
export var subPageLink = "K_gf d_gf";
export var burger = "K_wD";
export var sublinkSize = "K_wF";
export var linkSize = "K_wG";
export var Link = "K_tD y_tD y_sY y_th";